import { useCallback, useEffect, useState, useMemo } from 'react';
import { useFetchFilter, useUpdateFilter } from 'ui-model';

export const useSender = (selectedFacilitiesAndFacilitiesFromGroups: string[]) => {
  const hasOnlyOneFacilitySelected = selectedFacilitiesAndFacilitiesFromGroups.length === 1;
  const [sender, setSender] = useState<string | null>(null);
  const { mutateAsync: setFilter } = useUpdateFilter();
  const { data: filters, isLoading: isLoadingSender } = useFetchFilter();
  const senderFilter = useMemo(() => filters?.senderSelector?.sender, [filters?.senderSelector?.sender]);

  const handleSenderChange = useCallback(
    async (newSender: string | null) => {
      if (newSender !== sender) {
        setSender(newSender);
        await setFilter({ body: { senderSelector: { sender: newSender } } });
      }
    },
    [setFilter, sender],
  );

  useEffect(() => {
    if (senderFilter) {
      setSender(senderFilter);
    }
  }, [senderFilter]);

  useEffect(() => {
    if (hasOnlyOneFacilitySelected) {
      handleSenderChange(selectedFacilitiesAndFacilitiesFromGroups[0]);
    }
  }, [selectedFacilitiesAndFacilitiesFromGroups, hasOnlyOneFacilitySelected, handleSenderChange]);

  return { sender, setSender: handleSenderChange, isLoadingSender };
};
